import React from "react";
import { Button, Text } from "react-native-elements";
import { useRecoilCallback } from "recoil";
import { selfGuidedTourSelectedState } from "../client";
import { UNIT } from "../styles";
import { LoginButtons } from "./LoginButtons";
import { TwoChoiceModal, TwoChoiceModalProps } from "./TwoChoiceModal";

export const LoginOrTourModal: React.FC<
  Pick<TwoChoiceModalProps, "openRequests">
> = ({ openRequests }) => {
  const onTakeTour = useRecoilCallback(({ set }) => () => {
    set(selfGuidedTourSelectedState, true);
  });

  const choice1Content = (
    <>
      <Text style={{ marginBottom: UNIT }}>
        See what BomData can do without creating an account
      </Text>
      <Button
        title="Take the tour"
        onPress={onTakeTour}
        style={{ width: "80%", margin: "auto" }}
      />
    </>
  );

  const choice2Content = (
    <>
      <Text style={{ marginBottom: UNIT }}>
        I want to login and use real data
      </Text>
      <LoginButtons />
    </>
  );

  return (
    <TwoChoiceModal
      openRequests={openRequests}
      disableClose={true}
      modalHeader="Access BomData"
      choice1Header="Self Guided Tour"
      choice1Content={choice1Content}
      choice2Header="Login"
      choice2Content={choice2Content}
    />
  );
};
